Vue.component('edit-provider', {

    props: ['name', 'url'],

    template: '<a href="{{ url }}">{{ name }}</a>',

});